import { SrIcon } from "@/components/ui/SrIcon";
import { cn } from "@/lib/utils";

interface ChatSummaryButtonProps {
  unread: number;
  open: boolean;
  onClick: () => void;
}

/** «Oppsummer N uleste» i kanalhodet (VIB-3027). Grå og avslått når alt er lest. */
export function ChatSummaryButton({ unread, open, onClick }: ChatSummaryButtonProps) {
  const disabled = unread === 0;
  const label = disabled ? "Ingen uleste" : open ? "Skjul oppsummering" : `Oppsummer ${unread} ${unread === 1 ? "ulest" : "uleste"}`;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={open}
      title={disabled ? "Du har lest alt i denne kanalen" : "AI oppsummerer det du ikke har lest"}
      className={cn(
        "inline-flex h-9 items-center gap-2 rounded-lg border-[1.5px] px-3.5 text-[13px] font-medium",
        disabled
          ? "cursor-not-allowed border-border bg-[hsl(var(--surface-light))] text-muted-foreground"
          : "border-[var(--sr-revemoerk)] bg-[var(--sr-revemoerk)] text-white hover:opacity-90",
      )}
    >
      <SrIcon name="sparkles" className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
